import React from 'react';
import { View, Text } from 'react-native';

interface DeviceLabelValueRowProps {
  label: string;
  value: string;
}

const DeviceLabelValueRow: React.FC<DeviceLabelValueRowProps> = ({ label, value }) => (
  <View className="flex-row mt-2 gap-6">
    <Text className="text-base font-bold text-gray-900 w-36">{label}</Text>
    <Text className="text-base text-gray-500 flex-1 flex-shrink">{value}</Text>
  </View>
);

export default DeviceLabelValueRow;
